<script
  setup
  lang="ts"
  generic="
    ListingFilter extends {
      code: string;
      label: string;
      name: string;
      options: Array<Schemas['PropertyGroupOption']>;
      entities: Array<Schemas['ProductManufacturer']>;
    }
  "
>
import { inject, ref } from "vue";
import { getTranslatedProperty } from "@shopware/helpers";
import type { Schemas } from "#shopware";

const props = defineProps<{
  filter: ListingFilter;
}>();

const emits = defineEmits<{
  (e: "select-value", value: { code: string; value: unknown }): void;
}>();
const selectedOptionIds = inject<string[]>("selectedOptionIds");
const isFilterVisible = ref<boolean>(false);

const filterBody = ref(null);
onClickOutside(filterBody, () => (isFilterVisible.value = false));

const toggle = () => {
  isFilterVisible.value = !isFilterVisible.value;
};
</script>

<template>
  <div class="filter-wrap" ref="filterBody">
    <h3 class="filter-head" @click="toggle">
      <button
          type="button">
        <span>{{ filter.label !== 'manufacturer' ? filter.label : 'Marken' }}</span>
        <span class="ml-6 flex items-center">
          <i :class="[
              isFilterVisible
                ? 'i-carbon-chevron-down'
                : 'i-carbon-chevron-up',
            ]"
          />
        </span>
      </button>
    </h3>
    <transition name="fade" mode="out-in">
      <div v-show="isFilterVisible" id="filter-section-0" class="filter-body">
        <div class="form__checks">
          <div
              v-for="option in filter.options || filter.entities"
              :key="`${option.id}-${selectedOptionIds?.includes(option.id)}`"
              class="checkbox checkbox--alt form__checkbox"
              @click="emits('select-value', { code: filter.code, value: option.id })">
            <input
                :id="`filter-mobile-${filter.code}-${option.id}`"
                :checked="selectedOptionIds?.includes(option.id)"
                :name="filter.name"
                :value="option.name"
                type="checkbox"
                class="form-check-input"
            />

            <label :for="`filter-mobile-${filter.code}-${option.id}`" class="ml-3 text-gray-600">
              {{ getTranslatedProperty(option, "name") }}
            </label>
            <div
                v-if="option.colorHexCode"
                class="color-code"
                :style="`background-color: ${option.colorHexCode}`"
                :class="{'border-blue border-2': selectedOptionIds?.includes(option.id),}"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
